import Cookies from 'js-cookie'

class Cookie extends Cookies {

  static setDefaults(defaults) {
    Cookies.defaults = defaults;
  }

  static getAllCookie(){
    return this.get();
  }
  static clearAllCookie(){
      let cookies = this.get()
     for(let i in cookies) {
        this.remove(i,{domain: document.domain.split('.').slice(-2).join('.')})
        this.remove(i,{domain: location.hostname})
      }
  }

  static setCookies(arr) {
      arr.forEach((v,i) => {
        this.set(v['key'],v['value'],{expires:v['expires'],path:v['path'] || '/'})
      })
    }

}

Cookie.getCookie = Cookie.get;
Cookie.setCookie = Cookie.set;
Cookie.clearCookie = Cookie.remove;

export {
  Cookie as default
};



// WEBPACK FOOTER //
// ./src/utils/cookie.js